import { createSlice } from '@reduxjs/toolkit'

export const variantStocksSlice = createSlice({
    name:'variantStocks',
    initialState: {isLoading: true, data: [], error: null, selectedVariant: null, variantDetails: null},
    reducers:{
        addAll:(state, action) => {
            console.log('Called addAll');
            state.data.length = 0;
            state.data.push(...action.payload.data);
        },
        add:(state, action) => {
            let variantId = action.payload.data.variantId;
            //If variantId is in list then update the row else append to top of the list
            let index = state.data.findIndex(item => item.variantId === variantId);
            if(index !== -1){
                state.data[index] = action.payload.data;
            }else{
                state.data.unshift(action.payload.data);
            }
        },
        update: (state, action) => {
            let parentIndex = action.payload.parentIndex;
            let index = action.payload.index;
            let quantity = action.payload.quantity;

            let newVariantDetails = [...state.variantDetails];

            state.data[action.payload.index] = action.payload.data;

            let variant = { ...newVariantDetails[parentIndex] };
            variant.stocks = [...variant.stocks];
            
            // Perform the mutation safely
            variant.stocks[index].quantity = quantity;
            
            // Put the modified variant back into the array
            newVariantDetails[parentIndex] = variant;
            
            // Update state
            state.variantDetails = newVariantDetails;
        },
        remove: (state, action) => {
            let parentIndex = action.payload.parentIndex;
            let index = action.payload.index;    

            let newVariantDetails = [...state.variantDetails];

            // Deep copy the inner object and its 'stocks' array
            let variant = { ...newVariantDetails[parentIndex] };
            variant.stocks = [...variant.stocks];
            
            // Perform the mutation safely
            variant.stocks.splice(index, 1);
            
            // Put the modified variant back into the array
            newVariantDetails[parentIndex] = variant;
            
            // Update state
            state.variantDetails = newVariantDetails;
        },
        setSelectedVariant: (state, action) => {
            state.selectedVariant = action.payload.variant;
        },
        setVariantDetails: (state, action) => {
            state.variantDetails = action.payload.details;
        },
        error(state, action){
            state.error = action.payload.error
        }
    }
})

export const {addAll, add, update, remove, setSelectedVariant, setVariantDetails, error } = variantStocksSlice.actions
export default variantStocksSlice.reducer 